import _ from "lodash";
import apiCore from "services/apiCore";
import qualityAuth from "services/qualityAuth";

const externalContactService = {
    getExternalContact: function (externalContactId) {
        return apiCore.v2.get(
            "/externalcontacts/contacts/" + externalContactId
        );
    },

    /**
     * Checks if the user has permission to view the external contact for the given divisions.
     * @param {string[]} divisionIds - The division IDs to check.
     * @returns {boolean} - True if the user has permission to view the external contact for the given divisions, false otherwise.
     */
    canViewExternalContact: function (divisionIds) {
        return (
            qualityAuth.canViewRelateContact() ||
            qualityAuth.canViewExternalContactsContact(divisionIds)
        );
    },
};

externalContactService.getCachedExternalContact = _.memoize(
    externalContactService.getExternalContact
);

export default externalContactService;
